module.exports = __webpack_public_path__ + "static/media/LivrosFechado.53324d9d.png";